import React from 'react';
import styles from '../../css/centeredBar.module.css';

export default function CenteredBar({ children }) {
  return (
    <div className={styles.centeredBarRow}>
      {children}
    </div>
  );
}
